function makePopup() {
    var popup = document.createElement('div');
    popup.className = 'popup';
    popup.innerHTML = 'Popup';
    return popup;
}